import { useEffect, useState } from "react";
import { QuestionProps } from '../../../typings/register'
import QuestionTag from '../../../components/QuestionTag'
import { getCompleteProfileQuestions } from './../../../services/questionService';
import { HOMEPAGE } from "../../../navigation/Constants";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import AboutMeQuestion from './AboutMeQuestion'
import { useHistory } from 'react-router-dom';
import StepperPage from '../../../components/stepper/StepperPage';
import Loader from "react-loader-spinner";
import InterestQuestion from './../../../components/InterestQuestion';
import { QuestionIds } from "../../../helpers/Enums";

const CompleteProfileQuestions = () => {
    const [questions, setQuestions] = useState<QuestionProps[]>([]);
    const [components, setComponents] = useState<QuestionProps[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const member = useSelector((state: RootState) => state.member);
    let history = useHistory();

    useEffect(() => {
        fetchData();
    }, [])

    const fetchData = async () => {

        const { data } = await getCompleteProfileQuestions(member.memberCode);
        setQuestions(data);
        dataToComponenet(data);
        setIsLoading(false);
    };

    const dataToComponenet = (data: QuestionProps[]) => {
        let count = 1;
        const components: any = [];
        for (const key in data) {
            let component: any;
            if (data.length === count) {
                component = {
                    //development - interstquestion=21, produciton=16
                    component: data[key].questionId === QuestionIds.ABOUT_ME_QUESTION ? AboutMeQuestion : data[key].questionId === QuestionIds.INTEREST_QUESTION ? InterestQuestion : QuestionTag,
                    question: data[key],
                    title: "question",
                    isLast: true
                }
            } else {
                component = {
                    //development - interstquestion=21, produciton=16
                    component: data[key].questionId === QuestionIds.ABOUT_ME_QUESTION ? AboutMeQuestion : data[key].questionId === QuestionIds.INTEREST_QUESTION ? InterestQuestion : QuestionTag,
                    question: data[key],
                    title: "question",
                    isLast: false
                }
            }

            components.push(component);
            count++;
        }
        // cm
        setComponents(components);
    };

    const onClose = () => {
        // history.goBack();
        history.replace(HOMEPAGE);
    };

    return (
        isLoading ?
            <div style={{ height: "80vh", margin: "auto", display: 'flex', justifyContent: "center", alignItems: "center" }}>
                <Loader type="ThreeDots" color="#f47373" height={60} width={60} />
            </div>
            :
            <>
                <div>
                    <StepperPage
                        containStepperHeader={true}
                        components={components}
                        handleBackBrowserButton={false}
                        hasBackButton={true}
                        onClose={onClose}
                    />

                </div>
            </>
    )
}

export default CompleteProfileQuestions;